<template>
  <div class="ticketAgentSearchBox">
    <v-select
      v-model="ticketAgentStatus"
      v-if="pageType === 'ALL_PAGE'"
      :items="agentTypeList"
      item-text="name"
      item-value="value"
      class="UXselect agentTypeSelect"
      @change="callAgentListByBrandId"
      hide-details
      outline
      solo
      no-data-text="データがありません。"
    ></v-select>
    <v-select
      item-text="name"
      item-value="id"
      v-model="value"
      :items="items"
      :disabled="!agentSelectable"
      label="オペレーターの選択"
      class="UXselect"
      color="#6D8DFF"
      style="max-width: 500px;"
      deletable-chips
      multiple
      hide-details
      outline
      solo
      no-data-text="データがありません。"
    ></v-select>
  </div>
</template>

<script>
import eventBus from '@/event_bus'
import {mapGetters} from 'vuex'
import eventType from '@/components/menus/ticket/enums/eventType'
import TicketListUtil from '../../../util/ticket_list_util'
import OptionType from '../../../enums/ticketListOptionType'
import pageType from '../../../enums/pageType'

export default {
  props: {
    updateAgent: Function,
    agentSelectable: Boolean,
    pageType: String,
    ticketAgentId: Number
  },
  name: 'agentSelect',
  data: () => ({
    agents: [],
    value: [],
    items: [],
    isFirst: true,
    ticketAgentStatus: '',
    agentTypeList: [
      { value: '', name: '全体' },
      { value: 'ENABLE', name: '有効メンバー' },
      { value: 'DISABLE', name: '無効メンバー' }
    ]
  }),
  computed: {
    ...mapGetters([
      'currentTicketBrandId'
    ])
  },
  destroyed () {
    eventBus.$off(eventType.FETCH_TICKET_BRAND)
  },
  methods: {
    callAgentListByBrandId () {
      this.axios.get('/gateway/ticket/agent', {
        params: {
          brandId: this.currentTicketBrandId,
          status: this.ticketAgentStatus
        }}).then((res) => {
        if (res.data.code === 0) {
          this.items = res.data.data
        }
      })
    },
    resetAll () {
      if (this.pageType === pageType.MY_PAGE) {
        return false
      }
      this.value = []
    }
  },
  mounted () {
    eventBus.$on(eventType.FETCH_TICKET_BRAND, () => {
      this.callAgentListByBrandId()
      if (this.pageType === pageType.MY_PAGE) {
        this.value = [this.ticketAgentId]
      } else {
        this.value = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.AGENT, localStorage.getItem('TICKET_LIST_OPTION'))
      }
    })
  },
  watch: {
    value (data) {
      if (!this.isFirst) {
        this.updateAgent(data)
      }
      this.isFirst = false
    }
  }
}
</script>

<style lang="scss">
.ticketAgentSearchBox {
  display: flex;
  .agentTypeSelect {
    flex: 0 1 140px;
    margin-right: 10px;
    @media (max-width: 1280px) {
      width: 140px;
      margin-bottom: 10px;
    }
  }
  @media (max-width: 1280px) {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/agent_select.vue